import React from "react";

const AgentFilterDropdown = ({
  agents,
  filters,
  agentFilterText,
  onAgentToggle,
  onAllAgentsToggle,
}) => {
  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <span className="text-[#0A0F2D] text-base font-medium">
          Applied by: {agentFilterText}
        </span>
        <button
          onClick={onAllAgentsToggle}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
            filters.allAgentsSelected ? "bg-[#2283FF]" : "bg-gray-200"
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              filters.allAgentsSelected ? "translate-x-6" : "translate-x-1"
            }`}
          />
        </button>
      </div>

      <div className="mb-4">
        <div className="flex items-center border border-[#E9E9E9] rounded-lg px-3 py-2">
          <svg
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
            className="text-gray-400 mr-2"
          >
            <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="2" />
            <path
              d="M12 12L10.5 10.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
          <input
            type="text"
            placeholder="Search agents"
            className="flex-1 outline-none text-sm"
          />
        </div>
      </div>

      <div className="space-y-2 max-h-60 overflow-y-auto">
        {agents.map((agent) => (
          <div
            key={agent.id}
            className="flex items-center gap-3 p-2 hover:bg-gray-50 rounded"
          >
            <input
              type="checkbox"
              checked={filters.selectedAgents.includes(agent.id)}
              onChange={() => onAgentToggle(agent.id)}
              className="text-[#2283FF]"
            />
            <img
              src={agent.image || null}
              alt={agent.name}
              className="w-8 h-8 rounded-full object-cover bg-gray-200"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />
            <div
              className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-sm font-medium text-gray-600"
              style={{ display: "none" }}
            >
              {agent.name?.charAt(0) || "A"}
            </div>
            <span className="text-[#0A0F2D] text-sm">{agent.name}</span>
          </div>
        ))}
      </div>
    </>
  );
};

export default AgentFilterDropdown;
